import { PriceAdjustmentsTable } from "@/features/payments/price-adjustments-table";

export function PriceAdjustmentsScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Price Adjustments</h1>
        <p className="text-gray-600 mt-2">
          Audit discounts, fees, and other manual price adjustments applied
          across orders, shipments, and pickup bookings.
        </p>
      </div>
      <PriceAdjustmentsTable />
    </div>
  );
}
